
import DisputeTransactionView from "components/pages/DisputeTransactionPage/components/DisputeTransactionView";
import MainContentContainer from "components/shared/containers/MainContentContainer";
import { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { BCMSCurrency, BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import { CardOnFileMerchant, Transaction, TransactionDispute } from "model";
import DisputeTransactionStartPage from "components/pages/DisputeTransactionPages/DisputeTransactionStartPage";
import DisputeItemServicePage from "components/pages/DisputeTransactionPages/DisputeItemServicePage";
import ReviewingDisputePage from "components/pages/DisputeTransactionPages/ReviewingDisputePage";
import DisputeMerchandiseReasonPage from "components/pages/DisputeTransactionPages/DisputeMerchandiseReasonPage";
import PageContent from "components/shared/views/PageContent";
import RecentTransactionsPage from "components/pages/RecentTransactionsPage";
import CardOnFilePageV2 from "components/pages/CardOnFilePageV2";
import VerificationEnterCredsPage from "components/pages/VerificationEnterCredsPage";
import SecurityTokenReceiveTokenPage, { getDefaultData } from "components/pages/SecurityTokenReceiveTokenPage";


export default function Test1(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor([ CardOnFileMerchant ], controller);
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["cardOnFileMerchant", "howWouldYouLikeToReceiveTheSecurityToken"], "phone")
    .submit();

    return (
        <SecurityTokenReceiveTokenPage data={ {...data} } />
    );
}

/*export default function Test1(props) {
    const controller = useBCMSContext();

    const merchants = getDefaultData().cardOnFileMerchants;
    const merchant1 = merchants[6];
    merchant1.status = "card added";
    const merchant2 = merchants[5];
    merchant2.status = "card added";
    BCMSRecord.globalControllerFor([ CardOnFileMerchant ], controller);
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["cardOnFileMerchants"], merchants)
    .submit();

    return (
        <CardOnFilePageV2 data={ data } />
    );
}*/

/*export default function Test1(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor([ Transaction, TransactionDispute ], controller);
    const data = BCMSStateManagerCRUD.init(getDefaultData("3"))
    .update(["dispute", "whyAreYouDissatisfiedWithTheMerchandise"], "some reason")
    .update(["dispute", "wasTheMerchandiseDeliveredElectronically"], "no")
    .update(["dispute", "didYouReturnTheMerchandise"], "yes")
    .update(["dispute", "howDidYouReturnTheMerchandise"], "other")
    .update(["dispute", "howDidYouReturnTheMerchandiseOtherExplanation"], "some other reason")
    .update(["dispute", "whenWasTheMerchandiseReturned"], BCMSDate.init([3,3,2003]))
    
    .update(["dispute", "confirmationNumber"], "123")
    .update(["dispute", "whatAreYouTryingToDispute"], "services or experiences")
    .update(["dispute", "whatDidYouPurchase"], "some item")
    .update(["dispute", "transaction", "amount"], BCMSCurrency.init(3))
    .update(["dispute", "howMuchOfTheTransactionAmountAreYouDisputing"], "partial")
    .update(["dispute", "transaction", "merchant", "description"], "some merchant")
    .update(["dispute", "partialDisputeAmount"], BCMSCurrency.init(12))
    .update(["dispute", "transaction", "purchaseDate"], BCMSDate.init([2,2,2002]))
    .update(["dispute", "submissionDate"], BCMSDate.init([1,1,2001]))
    .submit();

    return (
        <DisputeMerchandiseReasonPage data={ data } />
    );
}*/
